var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-alc-img-fit",class:_vm.className},[_c('asset',{staticClass:"c-alc-img-fit__img",attrs:{"asset":_vm.image,"rounded":_vm.isImgCircle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }